/**
 * Absatz-Atome fuer den Lesemodus: fenced Code-Bloecke liegen als mehrere
 * CRDT-Absaetze vor (\\n\\n-Split) und muessen gebuendelt gerendert werden.
 */

export interface EditableParagraph {
  index: number
  text: string
  block_id?: string | null
}

export type ParagraphAtom =
  | { kind: 'single'; p: EditableParagraph }
  | { kind: 'codeblock'; paragraphs: EditableParagraph[] }

/** Bündelt Absätze zwischen zwei ```-Zäunen zu einem Atom, damit
 *  marked() den ganzen Code-Block sieht. */
export function buildParagraphAtoms<P extends EditableParagraph>(
  paragraphs: P[],
): Array<{ kind: 'single'; p: P } | { kind: 'codeblock'; paragraphs: P[] }> {
  const atoms: Array<{ kind: 'single'; p: P } | { kind: 'codeblock'; paragraphs: P[] }> = []
  let i = 0
  while (i < paragraphs.length) {
    const p = paragraphs[i]
    const fence = ((p.text || '').match(/```/g) || []).length
    if (fence % 2 === 1) {
      const acc: P[] = [p]
      let total = fence
      let j = i + 1
      while (j < paragraphs.length && total % 2 === 1) {
        const n = paragraphs[j]
        acc.push(n)
        total += ((n.text || '').match(/```/g) || []).length
        j++
      }
      atoms.push({ kind: 'codeblock', paragraphs: acc })
      i = j
    } else {
      atoms.push({ kind: 'single', p })
      i++
    }
  }
  return atoms
}

export function blockIdFor(p: EditableParagraph): string {
  return p.block_id || `_paragraph_${p.index}`
}
